let _functionId: string;
let _actionId: string;
let _actionName: string;
let _accessPrctCode: string | undefined;
export const actionName = {
  // 保存ボタン押下
  save: 'save',
  // 削除ボタン押下
  delete: 'delete',
  // 検索ボタン押下
  search: 'search',
  // 画面初期化
  init: 'init',
  // ダウンロードボタン押下
  down: 'download',
  // ダウンロードボタン押下
  asyncdown: 'asyncdown',
  // アップロードボタン押下
  up: 'upload',
  // スケジュールアップロードボタン押下
  upschedule: 'upschedule',
  // アーカイブボタン押下
  archive: 'archive',
  //フォーカスが離れる
  blur: 'blur',
  //フォーカスが当たる
  focus: 'focus',
  // コーヒーボタン押下
  copy: 'copy',
  //JP1送信ボタン押下
  isscheduleprocessing: 'isscheduleprocessing',
  // JP1送信ボタン押下
  prepare: 'prepare',
  // 承認ボタン押下
  approve: 'approve',
  // 送信ボタン押下
  send: 'send',
  // 実行ボタン押下
  exec: 'exec',
  // ジョブネットキック画面からジョブ実行状況の問い合わせ
  check: 'checkStatus',
  //カレンダーコード登録確認
  iscalendarcoderegistered: 'iscalendarcoderegistered',
  //登録ボタン押下
  register: 'register',
};
export function setRequestInfo(functionId: string, actionId: string, actionName: string, accessPrctCode?: string) {
  _functionId = functionId;
  _actionId = actionId;
  _actionName = actionName;
  _accessPrctCode = accessPrctCode;
}
export function getFunctionId() {
  return _functionId;
}
export function getActionId() {
  return _actionId;
}
export function getActionName() {
  return _actionName;
}

export function getAccessPrctCode() {
  return _accessPrctCode;
}
